import { render, staticRenderFns } from "./CompetitorsTable.vue?vue&type=template&id=3a20c725&"
import script from "./CompetitorsTable.vue?vue&type=script&lang=js&"
export * from "./CompetitorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports